import VariateConfig from '../config/VariateConfig/index.js'
import store from '@/store/index'
import {isInArray} from './GlobalFunction'
import provinces from '@/assets/utils/provinces'
/*函数式调用filter函数
formatVar -> filter函数名      this.bankId，bankList  filter函数的参数
this.$options.filters['formatVar'](this.bankId,'bankList')
* */
const vFilters = {
  /**
   * 功能：金额按千位逗号分隔
   * @param s 需要格式化的金额数值.
   * @param type 判断格式化后的金额是否需要小数位.
   * @returns {string} 返回格式化后的数值字符串.
   */
  formatMoney: (s, type = true) => {
    if (/[^0-9\.]/.test(s)) return '0.00'
    if (s == null || s == 'null' || s == '' || s == '0.00') return '0.00'
    s = s.toString().replace(/^(\d*)$/, '$1.')
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
    s = s.replace('.', ',')
    let re = /(\d)(\d{3},)/
    while (re.test(s)) s = s.replace(re, '$1,$2')
    s = s.replace(/,(\d\d)$/, '.$1')
    if (!type) {
      let a = s.split('.')
      if (a[1] == '00') {
        s = a[0]
      }
    }
    return s
  },
  /**
   *功能：截取超过设定长度的字符串
   * @param str 需要格式化的字符串
   * @param len 超过多少长度需要截取
   * @returns {*}   返回格式化后的字符串
   */
  formatString: (str, len) => {
    if (!len) return str //如果没传长度，则原样返回
    if (!str) return str //如果字符串不存在或者为假，也原样返回
    let strLen = str.length
    if (strLen <= len) {
      return str
    } else {
      return str.slice(0, len) + '...'
    }
  },
  /**
   * 功能：转换全局变量中Id为相对应的中文名称
   * @param id：要转换的全局变量id
   * @param key：要转换的全局变量key值
   * @returns {*}：id对应的name名称
   */
  formatVar: (id, key,name='name') => {
    if (!key || !(id + '')) return '';
    let res = VariateConfig[key].filter(item => item.id == id)[0];
    //住宿订单状态为100时，用户身份不同显示的文字不同
    if (isInArray([100],id) && isInArray(['HOrderStatus','TOrderStatus'],key)) {
      switch (store.getters.userInfo.type) {
        case 3:return '未成团';
        default:return  '询价完成';
      }
    }
    return res ? res[name] : ''
  },
  /**
   * 功能：转换星级Id数组为星级名称数组
   * @param stars：星级的ids
   * @returns {Array}：星级的name名称数组
   */
  formatStars: (stars,type) => {
    let matchStar = []
    if (!stars) return []               //值不存在，直接返回空数组
    stars.forEach(star => {
      matchStar.push(VariateConfig[type].filter(item => item.id == star)[0].name)
    })
    return matchStar
  },
    /**
   * 功能：转换星级Id数组为星级名称数组
   * @param other：星级的ids
   * @returns {Array}：星级的name名称数组
   */
  formatmeetRoomObj: other => {
    let matchStar = []
    if (!other) return '无'               //值不存在，直接返回空数组
    other.forEach(other => {
      matchStar.push(VariateConfig['meetRoomObj'].filter(item => item.id == other)[0].name)
    })
    return matchStar
  },
  /**
   * 功能：转换时间戳为常用的时间格式
   * @param timestamp 时间戳
   * @param flag  1,2,3
   * @returns {string} 1-> 2018-11-28 15:30:23   2->2018-11-28 星期三   3->15:30:23  默认->2018-11-28
   */
  formatTimestamp: (timestamp, flag) => {
    if (!timestamp||(timestamp + '').length <10) return ''
    var s = (timestamp + '').length === 10 ? timestamp * 1000 : timestamp || 0;               //时间戳为空时返回空
    let date = new Date(s)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let minute = date.getMinutes()
    let second = date.getSeconds()
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    let week = date.getDay(),
      weekArray = [
        { id: 0, title: '周日' }, { id: 1, title: '周一' }, { id: 2, title: '周二' },
        { id: 3, title: '周三' }, { id: 4, title: '周四' }, { id: 5, title: '周五' }, { id: 6, title: '周六' }
      ]
    let weekday = weekArray.filter(item => item.id === week)[0].title

    switch (String(flag)) {
      case '1':
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
      case '2':
        return y + '-' + m + '-' + d + '  ' + weekday
      case '3':
        return h + ':' + minute + ':' + second
      case '4':
        return y + '-' + m
      case '5':
        return y + '-' + m + '-' + d + ' ' + weekday
      case '6':
        return y
      default:
        return y + '-' + m + '-' + d
    }
  },
  /**
   * 功能：将手机号中间4位隐藏
   * @param phoneNumber 手机号
   * @returns {*}
   */
  formatPhone: phoneNumber => {
    if (!phoneNumber) return '';
    return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  },
  /**
   * 功能：将数字转为大写
   * @param num 数字
   * @returns {string}
   */
  numberToChinese :value=> {
      if (!value && value!== 0) return '';
      // 处理负数
      const isNegative = value < 0;
      value = Math.abs(value);
      
      // 分离整数和小数部分
      let [integer, decimal] = value.toFixed(2).split('.');
      decimal = decimal.padEnd(2, '0'); // 确保小数部分有两位
      
      // 转换整数部分
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const units = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟', '万'];
      
      let result = '';
      for (let i = 0; i < integer.length; i++) {
        const current = parseInt(integer[i]);
        const position = integer.length - i - 1;
        
        if (current!== 0) {
          result += digits[current] + units[position];
        } else {
          // 避免多个零连续出现，且万、亿单位需要保留
          if (['万', '亿'].includes(units[position]) && !result.endsWith(units[position])) {
            result += units[position];
          } else if (!result.endsWith('零') && position!== 0) {
            result += '零';
          }
        }
      }
      
      // 处理整数部分为零的情况
      if (result === '') result = '零';
      
      // 添加"元"
      result += '元';
      
      // 处理小数部分
      const decimalDigits = parseInt(decimal);
      if (decimalDigits === 0) {
        result += '整';
      } else {
        if (parseInt(decimal[0])!== 0) {
          result += digits[parseInt(decimal[0])] + '角';
        }
        if (parseInt(decimal[1])!== 0) {
          result += digits[parseInt(decimal[1])] + '分';
        }
      }
      
      // 添加负号（如果是负数）
      if (isNegative) {
        result = '负' + result;
      }
      
      return result;
  },
  /**
 * 按时间属性对对象数组排序
 * @param {Array} arr - 要排序的对象数组
 * @param {string} timeKey - 时间属性的键名
 * @param {boolean} isAsc - 是否升序（默认true）
 * @returns {Array} 排序后的数组
 */
  sortByTime:(arr, timeKey, isAsc = true) =>{
    // 创建数组副本，避免修改原数组
    return [...arr].sort((a, b) => {
      const timeA = new Date(a[timeKey]).getTime();
      const timeB = new Date(b[timeKey]).getTime();
      return isAsc ? timeA - timeB : timeB - timeA;
    });
  },
      /**
     * 获取本地省市区地址
     */
    obtainProvince:(id)=>{
     /*获取数据库所有省份、市、区数组*/
        let options =provinces.find(item => item.id === id);
        return options?options.title:'';
    },
}

export default vFilters;
